/**
 * Collapse-panel ids for the preview surfaces (#189).
 *
 * Their own module because three files need to agree on them —
 * TemplateDesignerRoute (which owns the preview half's state and feeds
 * SplitPane), PreviewToolbar (the collapse trigger) and PreviewPane (the ZPL
 * rail) — and importing a constant back out of PreviewPane would close an
 * import cycle with its own toolbar.
 *
 * They double as localStorage key segments, so renaming one silently resets
 * that panel to expanded for every existing user.
 */
export const PREVIEW_PANEL_ID = 'preview'
export const PREVIEW_ZPL_PANEL_ID = 'previewZpl'
